/**
 * Copies the plan/cluster links the Inspection service re-computed after a
 * recompartment onto the in-memory checklist items, matched by item Id.
 * Returns the number of items updated.
 */
export function applyChecklistLinks(targets: any[] | null | undefined, updated: any[] | null | undefined): number {
  if (!Array.isArray(targets) || !Array.isArray(updated)) return 0
  let count = 0
  for (const source of updated) {
    if (!source?.Id) continue
    const target = targets.find(item => item?.Id === source.Id)
    if (!target) continue
    target.PlanIds = Array.isArray(source.PlanIds) ? [...source.PlanIds] : null
    target.Clusterized = !!source.Clusterized
    target.ActionPlanId = source.ActionPlanId ?? null
    count++
  }
  return count
}

/**
 * Mirrors the region/section the Inspection service assigned to a moved point
 * (and its checklist links) onto the loaded inspection result. Returns false
 * when `source` is not the same inspection.
 */
export function applyInspectionLinks(elementResult: any, source: any): boolean {
  if (!elementResult || !source?.id || elementResult.id !== source.id) return false
  if (Array.isArray(source.RegionIds)) elementResult.RegionIds = [...source.RegionIds]
  if (source.InsertedRegionId) elementResult.InsertedRegionId = source.InsertedRegionId
  if (source.SectionId) elementResult.SectionId = source.SectionId
  applyChecklistLinks(elementResult.CheckList, source.CheckList)
  return true
}
